export const Order = (json: IOrder): IOrderModel => {
	const fromJSON = (json: IOrder) => {
		const { tpay_url, product_id, total_price, user_id, items, logs, created_at, updated_at, ...rest } = json

		return {
			...rest,
			tpayUrl: tpay_url,
			productID: product_id,
			totalPrice: total_price || total_price === 0 ? total_price / 100 : null,
			items: items ? items.map((item) => OrderItem(item)) : [],
			logs: logs ? logs.map((log) => OrderLog(log)) : [],
			userID: user_id,
			createdAt: created_at ? new Date(created_at) : null,
			updatedAt: updated_at ? new Date(updated_at) : null,
		}
	}

	return { ...fromJSON(json) }
}

export const orderToJSON = (obj: Partial<IOrderModel>): Partial<IOrder> => {
	const { tpayUrl, productID, ...rest } = obj

	return {
		...rest,
		tpay_url: tpayUrl,
		product_id: productID,
	}
}

export const OrderItem = (json: IOrderItem): IOrderItemModel => {
	const fromJSON = (json: IOrderItem) => {
		const { order_id, product_id, total_price, product, price, created_at, updated_at, ...rest } = json

		return {
			...rest,
			orderID: order_id,
			productID: product_id,
			totalPrice: total_price / 100,
			price: price / 100,
			product: product ? Product(product as IProduct) : null,
			createdAt: created_at ? new Date(created_at) : null,
			updatedAt: updated_at ? new Date(updated_at) : null,
		}
	}
	return { ...fromJSON(json) }
}

export const orderItemToJSON = (obj: Partial<IOrderItemModel>): Partial<IOrderItem> => {
	const { orderID, productID, totalPrice, price, product, ...rest } = obj

	return {
		...rest,
		order_id: orderID,
		product_id: productID,
		total_price: totalPrice ? totalPrice * 100 : undefined,
		price: price ? price * 100 : undefined,
		product: product ? productToJSON(product) : undefined,
	}
}

export const OrderLog = (json: IOrderLog): IOrderLogModel => {
	const { order_id, created_at, ...rest } = json

	return {
		...rest,
		orderID: order_id,
		createdAt: created_at ? new Date(created_at) : null,
	}
}
